import { z } from 'zod/v4';

export const costProfileSchema = z.object({
  id: z.string(),
  name: z.string(),
  status: z.number().optional(),
});

export type CostProfile = z.infer<typeof costProfileSchema>;
